import { render } from "./XIconSolidArchive.vue?vue&type=template&id=4615c2be"
import script from "./XIconSolidArchive.vue?vue&type=script&lang=js"
export * from "./XIconSolidArchive.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidArchive.vue"]])

export default __exports__